/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_SubInputs */

const th_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีของคุณ: คุณเป็นใครที่นี่ และผู้ที่คุณดูแล`)
};

const en_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account: who you are here, and the people you are responsible for.`)
};

const ja_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのアカウント: ここでの立場と、あなたが責任を持つ人たち。`)
};

const zh_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的账户：你在这里是谁，以及你负责什么。`)
};

const es_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta: quién eres aquí y las personas de las que te ocupas.`)
};

const pt_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta: quem você é aqui e as pessoas por quem você responde.`)
};

const id_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun Anda: siapa Anda di sini dan apa yang jadi tanggung jawab Anda.`)
};

const fr_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte : qui vous êtes ici, et les personnes dont vous répondez.`)
};

const tl_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang account mo: kung sino ka rito at kung ano ang pananagutan mo.`)
};

const vi_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của bạn: bạn là ai ở đây và bạn chịu trách nhiệm những gì.`)
};

const ko_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 계정: 여기서 나는 누구이고 무엇을 책임지는가.`)
};

const de_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Konto: wer du hier bist und für wen du Verantwortung trägst.`)
};

const ru_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш аккаунт: кто вы здесь и за что отвечаете.`)
};

const tr_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınız: burada kimsiniz ve neyden sorumlusunuz.`)
};

const it_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo account: chi sei qui e di cosa rispondi.`)
};

const pl_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje konto: kim tu jesteś i za co odpowiadasz.`)
};

const uk_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш обліковий запис: хто ви тут і за що відповідаєте.`)
};

const hi_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका खाता: आप यहाँ कौन हैं और किसके लिए ज़िम्मेदार हैं।`)
};

const ar_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حسابك: من أنت هنا وعمّ أنت مسؤول.`)
};

const ms_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun anda: siapa anda di sini dan apa tanggungjawab anda.`)
};

const bn_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার অ্যাকাউন্ট: এখানে আপনি কে এবং কীসের দায়িত্বে।`)
};

const zh_tw2_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的帳戶：你在這裡是誰，以及你負責什麼。`)
};

const zh_hk2_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的帳戶：你在這裡是誰，以及你負責什麼。`)
};

const ur_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کا اکاؤنٹ: یہاں آپ کون ہیں اور کس کے ذمہ دار ہیں۔`)
};

const fa_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب شما: اینجا که هستید و مسئول چه چیزی هستید.`)
};

const sw_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti yako: wewe ni nani hapa na unawajibika kwa nini.`)
};

const nl_profile_sub = /** @type {(inputs: Profile_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw account: wie je hier bent en waar je verantwoordelijk voor bent.`)
};

/**
* | output |
* | --- |
* | "Your account: who you are here, and the people you are responsible for." |
*
* @param {Profile_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_sub = /** @type {((inputs?: Profile_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_sub(inputs)
	if (locale === "ja") return ja_profile_sub(inputs)
	if (locale === "zh") return zh_profile_sub(inputs)
	if (locale === "es") return es_profile_sub(inputs)
	if (locale === "pt") return pt_profile_sub(inputs)
	if (locale === "id") return id_profile_sub(inputs)
	if (locale === "fr") return fr_profile_sub(inputs)
	if (locale === "tl") return tl_profile_sub(inputs)
	if (locale === "vi") return vi_profile_sub(inputs)
	if (locale === "ko") return ko_profile_sub(inputs)
	if (locale === "de") return de_profile_sub(inputs)
	if (locale === "ru") return ru_profile_sub(inputs)
	if (locale === "tr") return tr_profile_sub(inputs)
	if (locale === "it") return it_profile_sub(inputs)
	if (locale === "pl") return pl_profile_sub(inputs)
	if (locale === "uk") return uk_profile_sub(inputs)
	if (locale === "hi") return hi_profile_sub(inputs)
	if (locale === "ar") return ar_profile_sub(inputs)
	if (locale === "ms") return ms_profile_sub(inputs)
	if (locale === "bn") return bn_profile_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_sub(inputs)
	if (locale === "ur") return ur_profile_sub(inputs)
	if (locale === "fa") return fa_profile_sub(inputs)
	if (locale === "sw") return sw_profile_sub(inputs)
	if (locale === "nl") return nl_profile_sub(inputs)
	return en_profile_sub(inputs)
});